<template>
  <Dialog v-model:visible="showAdsetAdsModal" class="w-11/12 bg-white shadow rounded-xl" :modal="true" style="position:relative">
    <loading :active="!showSelectPostDialogMyside"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <template #header>
      <div class="w-full text-gray-900 font-semibold">
        {{lang['components']['Dialog']['SelectAdsetAdsDialog']['dialog_title']}}
        <button
          class="text-sm border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1 ml-4"
          @click="posts_data_update()">
          <i class="pi pi-refresh"></i>{{lang['components']['Dialog']['SelectAdsetAdsDialog']['update_button']}}
        </button>
      </div>
    </template>

    <div class="flex-wrap justify-between space-1-2 px-8">
      <Dropdown v-model="adaccountCampaignsId" :options="adaccountCampaignsList" optionLabel="name" optionValue="code" :filter="true" :placeholder="lang['components']['Dialog']['SelectAdsetAdsDialog']['adaccountCampaignsList_placeholder']" class="w-1/4 rounded-md" @change="getCampaignAdsetsData" />
      <Dropdown v-model="campaignAdsetsId" :options="campaignAdsetsList" optionLabel="name" optionValue="code" :disabled="adaccountCampaignsId == null" :filter="true" :placeholder="lang['components']['Dialog']['SelectAdsetAdsDialog']['campaignAdsetsList_placeholder']" class="w-1/4 rounded-md ml-4" @change="getAdsetAdsData" />
    </div>
    <div
      class="align-middle inline-block min-w-full shadow overflow-hidden bg-white shadow-dashboard px-8 pt-3 rounded-bl-lg rounded-br-lg">
      <!-- <DataTable :value="dataTableList" :paginator="true" class="p-datatable-customers" :rows="10"
            dataKey="id" :rowHover="true" v-model:selection="selectedCustomers" paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[10,25,50]"
            currentPageReportTemplate="顯示 {first} 至 {last} 項結果，共 {totalRecords} 項" responsiveLayout="scroll"> -->
      <DataTable :value="dataTableList" :paginator="true" class="p-datatable-customers" :rows="10"
            dataKey="id" :rowHover="true" v-model:selection="selectedCustomers" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" :rowsPerPageOptions="[10,25,50]"
            :currentPageReportTemplate="lang['components']['Dialog']['SelectAdsetAdsDialog']['datatable_page_info']" responsiveLayout="scroll">
        <Column selectionMode="multiple"></Column>
        <Column field="name" :header="lang['components']['Dialog']['SelectAdsetAdsDialog']['field_a']" :sortable="true" headerStyle="width: 30%">
          <template #body="slotProps">
            <div class="text-sm" v-html="slotProps.data.name"></div>
          </template>
        </Column>
        <Column field="campaign_name" :header="lang['components']['Dialog']['SelectAdsetAdsDialog']['field_b']" :sortable="true"></Column>
        <!-- <Column field="message" header="主要內容" :sortable="true"></Column> -->
        <Column field="message" :header="lang['components']['Dialog']['SelectAdsetAdsDialog']['field_c']" :sortable="true">
          <template #body="slotProps">
            <div class="text-sm" v-tooltip.top="`${slotProps.data.message_tooltip}`" v-html="slotProps.data.message"></div>
          </template>
        </Column>
        <!-- <Column field="touch" header="觸及人數" :sortable="true"></Column>
        <Column field="interactive" header="互動指數" :sortable="true">
          <template #body="slotProps">
            <div class="flex"><div class="star" v-for="n in slotProps.data.interactive" :key="n">★</div></div>
          </template>
        </Column>
        <Column field="link" header="連結指數" :sortable="true">
          <template #body="slotProps">
            <div class="flex"><div class="star" v-for="n in slotProps.data.link" :key="n">★</div></div>
          </template>
        </Column> -->
      </DataTable>
    </div>

    <template #footer>
      <div class="w-full justify-end py-4 border-t border-gray-400">
        <button
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-gray-400 transition duration-500 ease-in-out mt-32 border-2"
          @click="showAdsetAdsModal=false">{{lang['components']['Dialog']['SelectAdsetAdsDialog']['cancel_button']}}</button>
        <button
          class="bg-yellow-400 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out mt-32 border-2 border-yellow-400"
          :class="{ 'ring-4 border-blue-400': guideStep === 503 }"
          style="margin-right:72px;"
          @click="selected_click()">{{lang['components']['Dialog']['SelectAdsetAdsDialog']['yes_button']}}</button>
      </div>
    </template>
  </Dialog>
</template>

<script>
  // import { ref } from 'vue';
  import Dialog from 'primevue/dialog';
  import Dropdown from 'primevue/dropdown';
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'SelectPostDialog',
    components: {
      Dialog,
      Dropdown,
      DataTable,
      Column,
      Loading
    },
    props: {
      // <!-- 新手教學 -->
      guideStep: {
        type: Number,
        default: 501
      },
      // <!-- 新手教學 -->
      showAdsetAds: {
        type: Boolean,
        default: false
      },
      viewDatalist: {
        type: Object
      },
      adsetAdsDatalist: {
        type: Object
      },
      prviewAdsetAdsDatalist: {
        type: Object
      },
      pageId: {
        type: String
      },
      goalsObjectiveData: {
        type: String
      },
      specialAdCategory: {
        type: String
      },
      lang:{
        type: Object
      }
    },
    data() {
      return {
        showSelectPostDialogMyside: true,
        items: null,
        selectedCustomers: null,
        setPageId: null,
        adaccountCampaignsId: null,
        adaccountCampaignsList: [],
        campaignAdsetsId: null,
        campaignAdsetsList: [],
        dataTableList:[],
        dataType: '',
        // items: [{
        //     name: '新廣告活動',
        //     date: '2021/01/01',
        //     like: '100',
        //     comment: '200',
        //     share: '300',
        //     touch: '123',
        //     interactive: '5',
        //     link: '2',
        //   },
        //   {
        //     name: '新廣告活動',
        //     date: '2021/01/01',
        //     like: '100',
        //     comment: '200',
        //     share: '300',
        //     touch: '123',
        //     interactive: 4,
        //     link: 2,
        //   }
        // ]
      }
    },
    methods: {
      posts_data_update () {
        // console.log('pageId:'+this.pageId);
        this.showSelectPostDialogMyside = false;

        this.adaccountCampaignsId = null;
        this.campaignAdsetsId = null;
        this.campaignAdsetsList = [];
        this.dataTableList = [];
        this.dataType = 'update';

        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adaccount_campaigns.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            objective: this.goalsObjectiveData,
            type: this.dataType,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
            //  console.log('adset_ads_data');
            //  console.log(response.data.return_data.adaccount_campaigns_list);
              this.adaccountCampaignsList = response.data.return_data.adaccount_campaigns_list
            }

            this.showSelectPostDialogMyside = true;

          });
      },
      selected_click () {
      //  console.log('this.selectedCustomers');
      //  console.log(this.selectedCustomers);
        // console.log(this.pageIdData);

        let data_length = 0;
        if(this.selectedCustomers != '' && this.selectedCustomers != null && typeof this.selectedCustomers != 'undefined'){
          data_length = this.selectedCustomers.length;
        }

      //  console.log('data_length');
      //  console.log(data_length);

        if(data_length > 0 && data_length <= 10){
          this.showSelectPostDialogMyside = false;

          axios
            .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adset_ads_mark.php', Qs.stringify({
              s_code: this.$route.params.id,
              adset_id: this.campaignAdsetsId,
              page_id: this.pageId,
              form_data: this.selectedCustomers
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
              //  console.log('selected_click');
              //  console.log(response.data.return_data);
              //  console.log(response.data.return_prview);
                // this.items = response.data.return_data
                this.$emit('update:adsetAdsDatalist', response.data.return_data)
                this.$emit('update:prviewAdsetAdsDatalist', response.data.return_prview)

                this.showAdsetAdsModal = false

                this.selectedCustomers = null

                this.$emit('childAdsetAdsMaterialGetData', true);
              }

              this.showSelectPostDialogMyside = true;
            });
        } else {
        //  console.log('this.guideStep');
        //  console.log(this.guideStep);
          if(this.guideStep != '' && this.guideStep != null && this.guideStep != -1 && typeof this.guideStep != 'undefined'){
            this.showAdsetAdsModal = false
          } else {
            Swal.fire(
                        this.lang['components']['Dialog']['SelectAdsetAdsDialog']['methods']['selected_click']['have_not_length_swal_title'],
                        this.lang['components']['Dialog']['SelectAdsetAdsDialog']['methods']['selected_click']['have_not_length_swal_text'],
                        "warning"
                      )
          }
        }
      },
      getCampaignAdsetsData(){
      //  console.log('getCampaignAdsetsData');
      //  console.log(this.adaccountCampaignsId);

        let adaccountCampaignsId = this.adaccountCampaignsId
        if(adaccountCampaignsId != '' && adaccountCampaignsId != null && typeof adaccountCampaignsId != 'undefined'){
          this.showSelectPostDialogMyside = false;

          axios
            .post('https://www.autoturn.net/api/customize/campaign/campaign_form_campaign_adsets.php', Qs.stringify({
              s_code: this.$route.params.id,
              campaign_id: adaccountCampaignsId,
              type: this.dataType,
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                // console.log('selected_click');
              //  console.log(response.data.return_data.campaign_adsets_list);
                // console.log(response.data.return_prview);
                // this.items = response.data.return_data

                this.dataTableList = [];
                this.campaignAdsetsList = response.data.return_data.campaign_adsets_list
              }

              this.showSelectPostDialogMyside = true;
              this.campaignAdsetsId = null;
              this.dataTableList = [];
            });
        }
      },
      getAdsetAdsData(){
      //  console.log('getAdsetAdsData');
      //  console.log(this.campaignAdsetsId);

        let campaignAdsetsId = this.campaignAdsetsId
        if(campaignAdsetsId != '' && campaignAdsetsId != null && typeof campaignAdsetsId != 'undefined'){
          this.showSelectPostDialogMyside = false;
          this.dataTableList = [];

          axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adset_ads.php', Qs.stringify({
            s_code: this.$route.params.id,
            adset_id: campaignAdsetsId,
            page_id: this.pageId,
            type: this.dataType,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              // console.log('posts_data');
              // console.log(response.data.return_data);
              this.dataTableList = response.data.return_data
            }

            this.dataType = '';
            this.showSelectPostDialogMyside = true;
          });
        }
      }
    },
    // setup(props) {
    // //  console.log("Setup props:", props);

    //   watch((first, second) => {
    //   //  console.log("Watch function called with args:", first, second);
    //   });

    //   watch(props.selected, (first, second) => {
    //   //  console.log(
    //       "Watch props.selected function called with args:",
    //       first,
    //       second
    //     );
    //   });

    //   return {props};
    // },
    // setup() {
    //     const selectedCustomers = ref();
    //     return { selectedCustomers }
    // },
    watch: {
      'pageIdData': function(v){
        // console.log('selectpostdialog pageIdData:'+v);
      },
      'viewDatalist': function(v){
        // console.log('selectpostdialog viewDatalist:'+v);
      //  console.log('viewDatalist');
        this.adaccountCampaignsList = v;
        this.adaccountCampaignsId = null;
        this.campaignAdsetsList = [];
        this.campaignAdsetsId = null;
        this.dataTableList = [];
      }
    },
    computed: {
      showAdsetAdsModal: {
        get: function () {
          return this.showAdsetAds
        },
        set: function (value) {
          this.$emit('update:showAdsetAds', value)
        }
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      },
      pageIdData: {
        get: function () {
          return this.pageId
        },
        set: function (value) {
          this.$emit('update:pageIdData', value)
        },
      },
      specialAdCategoryData: {
        get: function () {
          return this.specialAdCategory
        },
        set: function (value) {
          this.$emit('update:specialAdCategoryData', value)
        },
      }
    }
  }
</script>

<style lang="scss" scope>
  .star {
    &:nth-child(1) {
      color: #FADB76;
    }
    &:nth-child(2) {
      color: #2FCABD;
    }
    &:nth-child(3) {
      color: #72B6F4;
    }
    &:nth-child(4) {
      color: #6298D7;
    }
    &:nth-child(5) {
      color: #1D619F;
    }
  }
</style>